import { getVapidKey, subscribePush } from './api/chat';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

// Đăng ký Service Worker + Web Push, gửi subscription về backend.
export async function registerPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  // Môi trường DEV (localhost): KHÔNG đăng ký push để khỏi trùng thông báo với bản web thật.
  // Nếu trước đó lỡ đăng ký thì gỡ subscription cũ. (Dev vẫn có popup in-app + âm thanh.)
  const isLocal = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname);
  if (isLocal) {
    try {
      const reg = await navigator.serviceWorker.getRegistration();
      const sub = reg && (await reg.pushManager.getSubscription());
      if (sub) await sub.unsubscribe();
    } catch { /* ignore */ }
    return;
  }
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') return;
    const { key } = await getVapidKey();
    if (!key) return;
    const sub =
      (await reg.pushManager.getSubscription()) ||
      (await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      }));
    await subscribePush(sub);
  } catch (err) {
    console.warn('Đăng ký push thất bại:', err?.message || err);
  }
}
